import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PatientSpaceService } from '../../_services/patient-space/patient-space.service';

@Component({
  selector: 'app-patient-home',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './patient-home.component.html',
  styleUrl: './patient-home.component.scss',
})
export class PatientHomeComponent implements OnInit {
  loading = true;
  data: any = null;

  constructor(private readonly patientSpaceService: PatientSpaceService) {}

  ngOnInit(): void {
    this.patientSpaceService.overview().subscribe({
      next: (response: any) => {
        this.data = response || null;
        this.loading = false;
      },
      error: () => {
        this.data = null;
        this.loading = false;
      },
    });
  }

  trackById(_: number, item: any): number {
    return Number(item?.id || 0);
  }
}
